"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangelogEntityTypes = void 0;
exports.ChangelogEntityTypes = [
    'post',
    'localization',
    'setting',
    'category',
];
